import { useCallback } from 'react';

const UseSlugRoute = () => {
	return useCallback((startWith, slug) => {
		return slug ? `${startWith}/${slug}` : startWith;
	}, []);
};

export default UseSlugRoute;
